<template>
  <div class="page-answer-statistics-container">
    <div class="answer-statistics-container">
      <label class="answer-statistics-label">
        항목별 선택비율
      </label>
      <div class="answer-statistics-list-container">
        <div
          class="answer-statistics-list"
          v-for="(value, index) in optionStatistics"
          :key="index"
        >
          <div class="answer-statistics-list-position" :class="{ 'correct': value.is_correct }">
            {{ index + 1}}
          </div>
          <div class="answer-statistics-progress-container">
            <div
              class="answer-statistics-bar"
              :style="{ width: `${getRatio(value.count, answerTotalCount) || 0}%` }"
            />
            <div class="answer-statistics">
              {{ getRatio(value.count, answerTotalCount) || 0 }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  orderBy, sumBy, find, map, isEmpty,
} from 'lodash';
import numbers from '@/mixins/numbers';

export default {
  name: 'quiz-answer-statistics',

  props: {
    quiz: {
      type: Object,
      default: () => {},
    },
    answerStatistics: {
      type: Array,
      default: () => {},
    },
  },

  mixins: [
    numbers,
  ],

  computed: {
    quizOptions() {
      return orderBy(this.quiz.answers, ['id'], ['asc']);
    },

    optionStatistics() {
      const results = map(this.quizOptions, (item) => {
        const answerStatistic = find(this.answerStatistics, { answer_id: item.id });
        if (!isEmpty(answerStatistic)) {
          return {
            ...item,
            count: answerStatistic.count,
          };
        }

        return item;
      });

      return results;
    },

    answerTotalCount() {
      return sumBy(this.optionStatistics, 'count') || 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-answer-statistics-container {
    max-width: 570px;
    padding: 0px 16px 0px 16px;
    margin: 0 auto;

    .answer-statistics-container {

      .answer-statistics-label {
        color: #808080;
        margin-bottom: 0;
        font-size: 14px;
      }

      .answer-statistics-list-container {
        padding: 14px 0 14px 0;

        .answer-statistics-list {
          padding: 0 0 14px 0;
          width: 100%;
          display: flex;

          .answer-statistics-list-position {
            display: inline-block;
            margin: 0 6px 0 0;
            border: 1px solid #cfcfcf;
            width: 24px;
            height: 24px;
            border-radius: 50px;
            line-height: 1.6;
            font-size: 14px;
            text-align: center;

            &.correct {
              border: 1px solid #03a9f4;
            }
          }

          .answer-statistics-progress-container {
            width: 100%;
            display: inline-flex;
            align-items: center;

            .answer-statistics-bar {
              display: inline-block;
              vertical-align: middle;
              width: 0%;
              height: 12px;
              background-image: linear-gradient(to left, rgb(72, 35, 174), rgb(151, 81, 199) 64%);
              border-radius: 4px;
              margin: 0 6px 0 0;
            }

            .answer-statistics-bar-hidden {
              display: inline-block;
              vertical-align: sub;
              width: 100%;
              height: 20px;
              background-image: url('~@/assets/images/bg_hidden.svg');
              background-position: center top;
              background-color: #f5f5f5;
              border-radius: 4px;
            }

            .answer-statistics {
              display: inline-block;
              color: #9013fe;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
</style>
